import { sendPackageOperationalEvent } from '../../../common/utils';
import { Logger } from '../../../common/utils/logger';
import { isThirdPartyAllowed } from '../third-party-verification';
export const checkThirdParty = async (thirdParty, onAllowed, onDenied) => {
  try {
    const isAllowed = await isThirdPartyAllowed(thirdParty);
    sendPackageOperationalEvent({
      action: 'usedCheckThirdParty',
      attributes: {
        wasRejected: !isAllowed,
        thirdParty
      }
    });
    return isAllowed ? onAllowed() : onDenied === null || onDenied === void 0 ? void 0 : onDenied();
  } catch (e) {
    Logger.errorWithOperationalEvent({
      action: 'checkThirdPartyError',
      attributes: {
        wasRejected: true,
        thirdParty
      },
      message: `Failed to use check third party. ${e.message || ''}`
    });
  }
};